export const AI_PARAMETER_MODE = {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    TEMPLATE: 'template'
} as const

export type AiParameterMode = typeof AI_PARAMETER_MODE[keyof typeof AI_PARAMETER_MODE]

export type AiParameterWizardMode =
    | typeof AI_PARAMETER_MODE.MULTIPLE
    | typeof AI_PARAMETER_MODE.TEMPLATE

export interface AiParameterValueJson {
    type: AiParameterMode
    data: string | string[]
    addCallLink?: boolean
}

export interface IAiDataField {
    key: string
    title: string
    group?: string
}

export interface ParameterOption {
    label: string
    value: string
}

export interface ParameterGroup {
    label: string
    options: Array<ParameterOption>
}
